export const UNTRACK_RELATIONSHIP_SUCCESS_MESSAGE =
  'Relationship has been untracked successfully!';
